module.exports = __webpack_public_path__ + "img/page_info_content.679a4e5.svg";